export interface DataVisualizationColorPalette {
  '100': string;
  '200': string;
  '300': string;
  '400': string;
  '500': string;
  '600': string;
  '700': string;
  ext100: string;
  ext200: string;
  ext300: string;
  ext400: string;
  ext500: string;
  ext600: string;
  ext700: string;
}

/* Categorical */
export type CategoricalPalette = Omit<DataVisualizationColorPalette, '700' | 'ext700'>;
export const CategoricalPalette: CategoricalPalette = {
  '100': '#0642A5',
  '200': '#206EF3',
  '300': '#196F72',
  '400': '#24A878',
  '500': '#A383E2',
  '600': '#774D9A',
  ext100: '#5993F7',
  ext200: '#99BEFE',
  ext300: '#61ABAC',
  ext400: '#83CFB3',
  ext500: '#CEBEED',
  ext600: '#9876BA',
};

/* Diverging */
export type DivergingPalette = Omit<
  DataVisualizationColorPalette,
  'ext300' | 'ext400' | 'ext500' | 'ext600' | 'ext700'
>;
export const DivergingPalette: DivergingPalette = {
  '100': '#0642A5',
  '200': '#206EF3',
  '300': '#5993F7',
  '400': '#989898',
  '500': '#E98E91',
  '600': '#CB5960',
  '700': '#BE2F38',
  ext100: '#99BEFE',
  ext200: '#F2C1C2',
};

/* Sequential */
export type SequentialPalette = Omit<
  DataVisualizationColorPalette,
  '700' | 'ext300' | 'ext400' | 'ext500' | 'ext600' | 'ext700'
>;
export const SequentialPalette: SequentialPalette = {
  '100': '#5993F7',
  '200': '#206EF3',
  '300': '#0B47C1',
  '400': '#092F7D',
  '500': '#011C52',
  '600': '#000000',
  ext100: '#C9DCFC',
  ext200: '#99BEFE',
};
